import React from 'react';

import PageTitleNew from 'components/ui/PageTitleNew';
import { Outlet, Link } from 'react-router-dom';
import routes from 'app/routes';
import Table from './Table';

export default function Index() {
  return (
    <>
      <PageTitleNew title="Resources" />

      <div className="ibox-content mt20">
        <div className="text-right">
          <Link
            to={routes.admin.resources.new}
            className="btn btn-primary"
          >
            Add Resource
          </Link>
        </div>

        <Table />
      </div>
      <Outlet />
    </>
  );
}
